import * as React from "react";
export function Card(p: React.HTMLAttributes<HTMLDivElement>) { return <div className="mc-card" {...p} />; }
export function CardHeader(p: React.HTMLAttributes<HTMLDivElement>) { return <div className="mc-card-hd" {...p} />; }
export function CardTitle(p: React.HTMLAttributes<HTMLHeadingElement>) { return <h3 className="mc-card-ttl" {...p} />; }
export function CardContent(p: React.HTMLAttributes<HTMLDivElement>) { return <div className="mc-card-bd" {...p} />; }
